import {
  InternalAdTrackingData,
  InternalAdTrackingDataParams,
} from "@shared/services/event_tracking/entities";

import type { ProductLine } from "@shared/types/ProductLine";

interface ProductCardAdEntityParams extends InternalAdTrackingDataParams {
  entry_type: string;
  entry_id: number;
  placement_position: number;
  price_bucket?: number;
}

export class ProductCardAdEntity extends InternalAdTrackingData {
  entry_type: string;
  entry_id: number;
  placement_position: number;
  price_bucket?: number;

  constructor(params: ProductCardAdEntityParams) {
    super(params);
    this.type = "product_card_ad";
    this.entity_version = 2;
    this.entry_type = params.entry_type;
    this.entry_id = params.entry_id;
    this.placement_position = params.placement_position;
    this.price_bucket = params.price_bucket;
  }

  static fromProductLine(product: ProductLine): ProductCardAdEntity {
    let trackingValues = product.paid_tracking_values;
    let values: ProductCardAdEntityParams = {
      campaign_content_ad_type: trackingValues.campaign_content_ad_type,
      entry_type: "product_line",
      entry_id: trackingValues.entry_id,
      campaign_id: trackingValues.campaign_id,
      campaign_content_id: trackingValues.campaign_content_id,
      campaign_segment_id: trackingValues.campaign_segment_id,
      placement_id: trackingValues.placement_id,
      placement_name: trackingValues.placement_name,
      placement_position: trackingValues.placement_position,
      placement_page_name: trackingValues.placement_page_name,
      placement_label: trackingValues.placement_label,
      placement_value: trackingValues.placement_value,
      sponsor_tags: null,
      contract_id: trackingValues.contract_id,
      price_bucket: product.price_bucket,
    };

    if (product.paid_sponsor_tags?.length > 0) {
      values.sponsor_tags = product.paid_sponsor_tags;
    }

    return new ProductCardAdEntity(values);
  }
}
